"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
const InputTags = ({
  children
}) => {
  const tagsRef = _react.default.useRef(null);
  _react.default.useEffect(() => {
    const handleMouseMove = event => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        const {
          isDragging
        } = tagsRef.current;
        if (isDragging && event.movementX) {
          tagsRef.current.scrollLeft -= event.movementX;
        }
      }
    };
    const handleMouseUp = () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = false;
      }
    };
    const tags = tagsRef.current;
    if (tags) {
      // @ts-expect-error TODO
      tags.addEventListener("mousemove", handleMouseMove);
      // @ts-expect-error TODO
      tags.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      if (tags) {
        // @ts-expect-error TODO
        tags.removeEventListener("mousemove", handleMouseMove);
        // @ts-expect-error TODO
        tags.removeEventListener("mouseup", handleMouseUp);
      }
    };
  }, [tagsRef]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("relative", "ms-sm", "flex flex-initial items-center", "h-full min-w-[50px]", "overflow-hidden", "z-[2]")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("overflow-x-scroll whitespace-nowrap", "space-x-xs flex items-center rtl:space-x-reverse", "scrollbar-none"),
    ref: tagsRef,
    onMouseDown: () => {
      if (tagsRef && tagsRef.current) {
        // @ts-expect-error TODO
        tagsRef.current.isDragging = true;
      }
    }
  }, children));
};
var _default = InputTags;
exports.default = _default;